import Vue from "vue";
import Vuex from 'vuex'
import state from './state'
import getters from './getter'
import mutations from './mutation'
import actions from './action'

// this.$store.dispatch('banner', res) // 向action中存
// this.$store.commit('load', true) // 向mutation中存
// this.$store.state.load // 获取数据
// this.$store.getters.cons // 获取处理后的数据

Vue.use(Vuex)

const vuex = new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    modules:{

    }
})

export default vuex